(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const slides = [...section.querySelectorAll('[data-media]')];
      const thumbs = [...section.querySelectorAll('[data-thumb]')];
      let index = 0;
      const show = next => {
        if (!slides.length) return;
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.hidden = i !== index;
          if (i !== index) slide.querySelectorAll('video').forEach(video => video.pause());
        });
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
        const count = section.querySelector('[data-gallery-count]');
        if (count) count.textContent = `${index + 1} / ${slides.length}`;
      };
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
      section.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(index - 1));
      section.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(index + 1));
      const data = section.querySelector('[data-variants]');
      if (!data) return;
      const variants = JSON.parse(data.textContent);
      const selector = section.querySelector('[data-variant-select]');
      const planSelector = section.querySelector('[data-selling-plan]');
      const requiresPlan = JSON.parse(section.querySelector('[data-plan-required]').textContent);
      const atc = section.querySelector('[data-atc]');
      const buyNow = section.querySelector('[data-buy-now]');
      const status = section.querySelector('[data-purchase-status]');
      const quantity = section.querySelector('input[name="quantity"]');
      const bundleOptions = [...section.querySelectorAll('[data-bundle-quantity]')];
      const syncBundleOptions = () => {
        const amount = Number(quantity.value);
        bundleOptions.forEach(option => option.setAttribute('aria-pressed', String(amount === Number(option.dataset.bundleQuantity))));
      };
      bundleOptions.forEach(option => option.addEventListener('click', () => {
        const amount = Number(option.dataset.bundleQuantity);
        if (Number(quantity.min) > amount || (quantity.max && Number(quantity.max) < amount) || (amount - Number(quantity.min)) % Number(quantity.step || 1) !== 0) {
          status.textContent = 'This option is unavailable for the selected quantity.';
          return;
        }
        quantity.value = amount;
        quantity.dispatchEvent(new Event('change', {bubbles: true}));
        status.textContent = amount === 2 ? 'Two selected. Bundle savings apply in your cart or at checkout.' : 'One selected.';
      }));
      quantity.addEventListener('input', syncBundleOptions);
      quantity.addEventListener('change', syncBundleOptions);
      syncBundleOptions();
      buyNow?.addEventListener('click', async event => {
        event.preventDefault();
        const form = buyNow.closest('form');
        if (!form.reportValidity()) return;
        if (document.body.dataset.designPreview) {
          status.textContent = 'Preview only. Buy now will take customers to Shopify checkout after upload.';
          return;
        }
        buyNow.disabled = true;
        atc.disabled = true;
        buyNow.textContent = 'Opening checkout…';
        status.textContent = '';
        try {
          const response = await fetch(section.dataset.cartAddUrl, {method:'POST', body:new FormData(form), headers:{Accept:'application/json'}});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Could not add this item. Please try again.');
          location.assign(section.dataset.checkoutUrl);
        } catch (error) {
          status.textContent = error.message || 'Could not open checkout. Please try again.';
          buyNow.disabled = false;
          atc.disabled = false;
          buyNow.textContent = 'Buy now';
        }
      });
      const update = (changeUrl = false) => {
        const id = selector?.value || section.querySelector('input[name="id"]')?.value;
        const variant = variants.find(v => String(v.id) === String(id));
        if (!variant) return;
        const bundleOffer = section.querySelector('[data-bundle-offer]');
        if (bundleOffer) bundleOffer.hidden = variant.price_cents !== 9499;
        const previousPlan = planSelector?.value;
        if (planSelector) {
          planSelector.replaceChildren();
          if (!requiresPlan) planSelector.add(new Option('One-time purchase', ''));
          variant.plans.forEach(plan => planSelector.add(new Option(`${plan.name} — ${plan.price}`, plan.id)));
          if ([...planSelector.options].some(option => option.value === previousPlan)) planSelector.value = previousPlan;
          planSelector.disabled = !variant.plans.length;
        }
        const plan = variant.plans.find(p => String(p.id) === planSelector?.value);
        section.querySelector('[data-price]').textContent = plan?.price || variant.price;
        const compare = section.querySelector('[data-compare]');
        compare.textContent = variant.compare;
        compare.hidden = !variant.on_sale || !!plan;
        const saleLabel = section.querySelector('[data-sale-label]');
        if (saleLabel) { saleLabel.textContent = variant.sale_label; saleLabel.hidden = !variant.on_sale || !!plan; }
        const unavailable = !variant.available || (requiresPlan && !variant.plans.length);
        atc.disabled = unavailable;
        if (buyNow) { buyNow.disabled = unavailable; buyNow.textContent = unavailable ? 'Sold out' : 'Buy now'; }
        if (status) status.textContent = '';
        atc.textContent = unavailable ? 'Sold out' : 'Add to cart →';
        quantity.min = variant.min;
        quantity.step = variant.increment;
        if (variant.max) quantity.max = variant.max; else quantity.removeAttribute('max');
        quantity.value = variant.min;
        syncBundleOptions();
        if (variant.media_id) {
          const mediaIndex = slides.findIndex(slide => slide.dataset.media === String(variant.media_id));
          if (mediaIndex >= 0) show(mediaIndex);
        }
        if (changeUrl && location.pathname.includes('/products/')) {
          const url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
        }
      };
      selector?.addEventListener('change', () => update(true));
      planSelector?.addEventListener('change', () => {
        const variant = variants.find(v => String(v.id) === (selector?.value || section.querySelector('input[name="id"]')?.value));
        const plan = variant.plans.find(p => String(p.id) === planSelector.value);
        section.querySelector('[data-price]').textContent = plan?.price || variant.price;
        section.querySelector('[data-compare]').hidden = !variant.on_sale || !!plan;
        const saleLabel = section.querySelector('[data-sale-label]');
        if (saleLabel) saleLabel.hidden = !variant.on_sale || !!plan;
      });
      update();
    });
  }
  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

